import * as types from './types';

export const actions = {
  async [types.DTGPTChats.FETCH.ALL]({ commit }, payload) {
    // const { startRow } = payload;
    // const contactsRes = await ContactsService.findContacts({
    //   start: startRow
    // });

    // console.log(contacts.data);

    const data = [];
    commit(types.DTGPTChats.SET.ALL, data);
  },
  async [types.SET_SHOW_CHATS]({ commit, getters }, payload) {
    // console.log(payload);
    commit(types.SET_SHOW_CHATS, payload);
  }
}